<template>
  <van-image-preview
    v-model="visible"
    :start-position="index"
    :showIndex="showIndex"
    :images="imageUrlList"
    :closeable="true"
    @close="closeView"
  ></van-image-preview>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "image-view",
  data() {
    return {
      visible: false,
      index: 0,
      showIndex: true,
    };
  },
  computed: {
    ...mapGetters(["imageUrlList"]),
  },
  mounted() {
    this.initWiew();
  },
  methods: {
    initWiew() {
      if (this.imageUrlList.length != 0) {
        var startIndex = this.$route.query.index;
        if (/\d/.test(startIndex)) {
          this.index = parseInt(startIndex);
        } else {
          if (startIndex == "avatar") {
            this.showIndex = false;
          }
        }
        this.visible = true;
      } else {
        this.$message({
          message: "图片找不到了",
          type: "warning",
          offset: 50,
        });
        setTimeout(() => {
          this.$router.back();
        }, 1000);
      }
    },
    closeView() {
      this.$router.back();
    },
  },
};
</script>